












import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { fetchCambioServicio } from './fetchCambioServicio';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

@Component({
  components: {
    DatePicker,
    FormFieldsContainer,
  },
})
export default class retiroEquipo extends Vue {
  constructor() {
    super();
  }

  @Prop({ default: null }) accion_modal: any;
  @Prop({ default: '(No haz seleccionado ningun equipo para la operación)' })
  envio_Equipo: any;
  @Prop({ default: null }) envio_numero: any;
  @Prop({ default: null }) numero_de_servicio: any;
  readonly loadingService = new LoadingService();
  model_serienumero: any = null;
  model_tipoeqname: any = null;
  lista_tipoeqname: any = null;

  formFields: FormFieldDefMap = {
    model_serienumero: {
      label: 'Serie Número*',
      id: '',
      value: '',
    },
    model_tipoeqname: {
      label: 'Tipo de Equipo',
      id: '',
      value: '',
    },
    serie_activa_numero: {
      label: 'Serie Activa Número',
      id: '',
      value: '',
    },
    sim_serie_numero: {
      label: 'Sim Serie Número',
      id: '',
      value: '',
    },
    patente: {
      label: 'Patente Vehículo',
      id: '',
      value: '',
    },
    vehiculo_id: {
      label: 'Vehículo Id',
      id: '',
      value: '',
    },
    cod_flota: {
      label: 'Código Flota',
      id: '',
      value: '',
    },
    cliente_id: {
      label: 'Cliente ID',
      id: '',
      value: '',
    },
  };

  async get_tipoeq() {
    this.loadingService.showLoading(undefined, 'get_tipoeq');
    return fetchCambioServicio({}, 'conectaCambioServicio/get_tipoeq')
      .then((data: any) => {
        this.loadingService.hideLoading('get_tipoeq');
        let res = data.data.LISTA;
        this.lista_tipoeqname = res;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  } //end get_tipoeq

  async buscar_serie_numero() {
    //MicroServicios/catalogo/conectaCambioServicio.py
    this.loadingService.showLoading(undefined, 'buscar_serie_numero');
    return fetchCambioServicio(
      { numero_serie: this.formFields.model_serienumero.value },
      'conectaCambioServicio/buscar_equipo_por_serie'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('buscar_serie_numero');
        this.lista_tipoeqname = data.data.LISTA;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  } //end buscar_serie_numero
  @Watch('formFields')
  onModelTipoCambioChanged(val: any, oldVal: any) {
    this.$emit('input', this.formFields);
  }

  async mounted() {
    await this.get_tipoeq();
    if (this.accion_modal == 'EDITAR') {
      this.envio_Equipo = 'El equipo fue dado de baja.';
    }
  }
} //end class
